module.exports = __webpack_public_path__ + "static/media/sort-size-down-alt.0c61e0bf.svg";